import { render, staticRenderFns } from "./ActionItems.vue?vue&type=template&id=552d4e98&scoped=true"
import script from "./ActionItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionItems.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActionItems.vue?vue&type=style&index=0&id=552d4e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d4e98",
  null
  
)

export default component.exports